import { ErrorMessage, Field } from "formik";
import React, { useState } from "react";
import TextError from "./TextError";
import Input from "./Input";
import { childDisplay, valudatesetformstatus } from "../../pages/onboarding/Onboarding";
import { oldFile } from "../../config/onboarding/onBoarding";
import { Modal, Button } from "react-bootstrap";
import ModalConfirmation from "../modal/ModalConfirmation";

interface ModalConfirmationProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
}

const RadioButton = (props: any) => {
    const { name, label, option, className, allData, onChange, formik, setDoTfnFormValidation, ...rest } = props;
    const [showModal, setShowModal] = useState(false);
    const [tfnFieldName, setTfnFieldName] = useState("");
    const [pensionErrorMsg, setPensionErrorMsg] = useState("");
    const [controlChildValue, setControlChildValue] = useState({
        data: false,
        value: "Yes"
    });

    const getTfnFormFieldValue = (baseName: string, rows: number, columns: number, clear: boolean = false) => {
        const values: string[] = [];
        for (let row = 0; row < rows; row++) {
            for (let col = 0; col < columns; col++) {
                const fieldId = `${baseName}-${row}-${col}`;
                const element = document.getElementById(fieldId);
                const fieldValue = element ? (element as HTMLInputElement).value : "";
                if (fieldValue !== "") {
                    if(clear === false){
                        values.push(fieldValue);
                    }else{
                        if (element) {
                            formik.setFieldValue(fieldId, ""); // Clear the value in Formik state
                            formik.setFieldError(fieldId, "");
                            (element as HTMLInputElement).value = ""; // Clear the value of the input field
                            element.dispatchEvent(new Event("input", { bubbles: true })); // Trigger input event to update React state
                        }
                    }
                }else{
                    formik.setFieldError(fieldId, "");
                }
            }
        }
        return values.join("");
    };

    const handlePensionFormFieldValue = (name: string) => {
        let tfnValue = "";
        
        if(name !== "" && name !== undefined && name !== null){
            tfnValue =  getTfnFormFieldValue(name, 3, 3);
            setTfnFieldName(name);
            setDoTfnFormValidation(name);
        }else{
            tfnValue = "";
            setTfnFieldName("");
            // setDoTfnFormValidation("");
        }

        if(tfnValue?.length > 0){
            setPensionErrorMsg("TFN Number will be deleted");
            setShowModal(true);
            
        }else{
            setPensionErrorMsg("");
            
        }
        return tfnValue;
    };

    const onConfirm = () => {
        let fdsf = getTfnFormFieldValue(tfnFieldName, 3, 3, true);
        setDoTfnFormValidation(tfnFieldName);
        setShowModal(false);
    };


    const fieldValidation = (value: any) => {
        let error;
        if (allData.validate) {
            if (allData.type === "radio-group") {
                allData?.validations.forEach((element: any) => {
                    if (allData.type === "radio-group") {
                        if (!value && valudatesetformstatus !== "draft") {
                            if (element.type ==="required") {
                                error = element.params[0];
                            }
                        }
                    }
                });
            }
        }
        return error;
    };

    const handleChildElement = (e: any) => {
        const childDisplayArr = childDisplay?.child_display;
        if(childDisplayArr?.length > 0){
            childDisplayArr.forEach((ress: any) => {
                if (!ress.includes("html-")) {
                    formik.setFieldValue(ress, "");
                }
            });
        }

    };

    const handleSuperFormSectionC = async (e: any, ress: any) => {
        if (ress?.filledByEmployer === true) {
            await Promise.all(
                (ress?.childFieldList || []).map(async (childElement: any) => {
                    if (childElement?.boxCount > 0) {
                        // Update the main field
                        await formik.setFieldValue(childElement?.field, childElement?.defaultValue);
                        await formik.setFieldTouched(childElement?.field, true, false);

                        // Update the split fields
                        const splitLength = Array(childElement?.boxCount).fill(null);
                        await Promise.all(
                            splitLength.map(async (_: any, index: number) => {
                                const fieldKey = `${childElement?.field}-${index}`;
                                await formik.setFieldValue(fieldKey, childElement?.defaultValue?.[index]);
                                await formik.setFieldTouched(fieldKey, true, false);
                            })
                        );
                    } else {
                        // Update the field directly
                        await formik.setFieldValue(childElement?.field, childElement?.defaultValue);
                        await formik.setFieldTouched(childElement?.field, true, false);
                    }
                })
            );
        }
    };

     const handleOnhide = () => {
        formik.setFieldValue(name, "");
        setShowModal(false);
        setDoTfnFormValidation("");
    };


    return (
        <>
            <ModalConfirmation
                show={showModal}
                onHide={handleOnhide}
                onConfirm={onConfirm}
            />
            <Field name={name} validate={fieldValidation}  {...rest}>
                {
                    ({ field }: any) => {

                        
                        return option.map((ress: any, index: any) => {
                            return (
                                <>
                                    <div key={ress.value} className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id={`${ress.value}-${index}-${field.name}`}
                                            {...field}
                                            value={ress.value}
                                            checked={field.value === ress.value} 
                                            onBlur={handleChildElement}
                                            onClick={(e: any) => {
                                                handleSuperFormSectionC(e, ress);
                                                handlePensionFormFieldValue(ress?.tfnFieldName);
                                            }}
                                        />
                                        <label className={`form-check-label ${ress?.labelMaxWidthClass}`} htmlFor={`${ress.value}-${index}-${field.name}`} dangerouslySetInnerHTML={{
                                                  __html: ress.label
                                                }}></label>
                                                {
                                                    (ress?.suggestionText ? (
                                                        
                                                        <div
                                                        className="suggestion-text"
                                                        dangerouslySetInnerHTML={{
                                                        __html: ress?.suggestionText,
                                                        }}
                                                        ></div>

                                                    ) : "")
                                                }
                                    </div>
                                </>
                            );

                        });
                    }
                }

            </Field>
            <ErrorMessage name={name} component={TextError} />

        </>
    );
};

export default RadioButton;